<template>
  <div class="content new-profile">
    <div class="md-layout" @click="selectArea($event)">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <profile-steps />
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="md-layout md-gutter md-alignment-center-center">
          <div class="searchResultWpr">
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-left-sec">
              <span class="md-title profile-title">Valuation Report <try-beta-pill product="valuation_report" :data-id="dataId" /></span>
              <div>
                <p class="description">
                  Combine our valuation data with your inputs for instant
                  insight into the estimated value of a company. This report
                  utilizes Deal Stats transactional records, Bizminer industry
                  KPIs, and four valuation methods. Further customize results
                  with subjective value indicators, company narrative, and more.
                </p>
                <ul class="profile_details">
                  <li v-if="industry">
                    <div>
                      <p class="h3-p">{{ industry }}</p>
                      <p class="h6-p">Industry</p>
                    </div>
                  </li>
                  <li v-if="marketArea">
                    <div>
                      <p class="h3-p">{{ marketArea.split("[")[0] }}</p>
                      <p class="h6-p">Market Area</p>
                    </div>
                  </li>
                  <li v-if="salesClass">
                    <div>
                      <p class="h3-p">{{ salesClass.split("[")[0] }}</p>
                      <p class="h6-p">Sales Class</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50 profile-right-sec">
              <PulseLoader :loading="loading" :class="{ hide: !loading }"></PulseLoader>
              <div class="md-layout">
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100 fin-pro-card no_padding">
                  <profile-card class="toolbar-card">
                    <template slot="header">
                      <div class="toolbar-card-title">
                        <p class="title text-left h5-p">Operations</p>
                      </div>
                    </template>
                    <template slot="content">
                      <div class="info-wrap">{{ operations }}</div>
                    </template>
                  </profile-card>
                </div>
                <div v-if="productPrice && !isAccessible"
                  class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                  <div class="md-layout-item mt-10">
                    <div class="product-price-label">
                      <h3 class="title text-center">
                        Price:
                        <span class="product-price">${{ productPrice }}</span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
                  <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
                    <template>
                      <!-- <router-link
                        :to="{
                          name: 'Competitors',
                          params: { id: this.profileId },
                        }"
                      >-->
                      <md-button v-if="isAccessible" @click.native="confirmationModal = true" :disabled="isDisabled"
                        class="md-info md-block access-button">
                        <span>Access Now</span>
                      </md-button>
                      <md-button v-else @click.native="access" :disabled="isDisabled"
                        class="md-info md-block access-button">
                        <span>Add To Cart</span>
                      </md-button>
                      <!-- </router-link> -->
                    </template>
                    <div class="alert md-layout-item" v-if="notAvailable">
                      <span class="closebtn" @click="closeAlert">&times;</span>
                      Sorry, we do not have enough data available for this
                      selection. Please try again.
                    </div>
                    <!-- <pulse-loader :color="'blue'" :loading="loading">
                    </pulse-loader>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prospect_content">
      <modal v-if="confirmationModal" @close="confirmationModal = false">
        <template slot="header">
          <button type="button" class="close_btn" @click="confirmationModal = false">
            <md-icon>clear</md-icon>
          </button>
        </template>
        <template slot="body">
          <div class="field_wpr">
            <h4 class="modal-title">
              Please confirm access to this product with the selected
              parameters. Click Review to review the parameters or Access Now to
              access this product.
            </h4>
            <div class="ml-4 md-layout">
              <md-button @click="confirmationModal = false"
                class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Review</md-button>
              <md-button @click="access" class="md-layout-item md-medium-size-40 md-xsmall-size-40 md-size-40">Access
                Now</md-button>
            </div>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>

<script>
import { Modal, ProfileCard, PulseLoader } from "@/components";
import ProfileSteps from "./_valuation_partials/ProfileSteps.vue";
import TryBetaPill from "./SelectorBeta/TryBetaPill.vue";
import { trackSelectorViewed, trackSelectorCompleted } from "./SelectorBeta/analytics";
import axios from "axios";
import { mapState } from "vuex";
// import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

export default {
  name: "new-valuation-report",
  components: {
    ProfileCard,
    ProfileSteps,
    TryBetaPill,
    PulseLoader,
    Modal,
  },
  data() {
    return {
      confirmationModal: false,
      isDisabled: true,
      operations: "",
      loading: false,
      myData: null,
      years: this.valuationData,
      isAccessible: true,
      productPrice: null,
      notAvailable: false,
    };
  },
  props: ["dataId", "valuationData", "isCSV", "file"],
  methods: {
    closeAlert: function () {
      this.notAvailable = false;
    },
    selectArea: function (e) {
      let parentDiv = document.querySelectorAll(".custom-step-pro");
      let deactiveClass = document.querySelectorAll(".step-progress__step");
      let favoriteDropdown = document.querySelectorAll(".favourite_list");
      deactiveClass.forEach(function (el) {
        el.classList.remove("open");
      });
      favoriteDropdown.forEach(function (el) {
        el.classList.remove("open");
      });
      parentDiv.forEach(function (el) {
        el.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      });
    },
    getData: function (name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    access: async function () {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + "/user/create/valuationReport",
          {},
          {
            params: {
              session_id: currentSession,
              product_id: this.profileId,
              industry: this.getData(this.industry),
              sales_class: this.getData(this.salesClass),
              area: this.getData(this.marketArea),
              map_center: "0",
              map_center_zip: "0",
              radius: "0",
              zips: "0",
              type: "valuation",
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/create/valuationReport" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          // const { access, location } = res.data;

          let id = res.data.id;
          this.$store.commit("V_SET_PROFILE_ID", id);

          if (this.dataId) {
            this.addInputsForReport(id);
          } else {
            let params = {
              product_id: id,
            };

            this.$store.dispatch("cart/accessProduct", params).then((res) => {
              if (res.cart) {
                this.$router.push({
                  name: "Cart",
                  params: { id: id },
                });
              }

              if (
                res.access ||
                (res.error && res.errorCode === "product_already_accessed")
              ) {
                trackSelectorCompleted("valuation_report", "classic");
                this.$router.push({
                  name: "VRAbouttheData",
                  params: { id: id },
                });
              }
            });
          }
        });
    },
    checkAccess: async function () {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );
      let resZips = "0";
      let resArea = 0;
      let resMap_center = "0";
      let resMap_center_zip = "0";
      let resRadius = "0";

      await axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/IF_available", {
          params: {
            session_id: currentSession,
            // product_id: this.profileId,
            industry: this.getData(this.industry),
            area: this.getData(this.marketArea),
            sales_class: this.getData(this.salesClass),
            zips: this.marketArea.includes("zips")
              ? this.marketArea.split("[")[0]
              : null,
            map_center: resMap_center,
            map_center_zip: resMap_center_zip,
            radius: resRadius,
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode +
              `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/products/checkAccess" <br>`
            );
            throw new Error(
              "<br>" +
              "Server responded with error = True <br> errorCode: " +
              res.data.errorCode
            );
          }
          const { access, ready } = res.data;
          // this.isAccessible = access;
          this.productPrice = res.price;
          let error = res.data.error;

          if (!error && this.salesClass && this.marketArea && this.industry) {
            this.isDisabled = false;
          } else {
            this.isDisabled = true;
          }
          this.loading = false;
        });
    },
    checkAccessByType: async function () {
      if (this.subscriptions.includes("vpro")) this.isAccessible = true;
      else this.isAccessible = false;
    },
    addInputsForReport: async function (profileId) {
      this.loaded = false;
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      let data = {
        toggle_current_ratio_check: true,
        toggle_days_payable_check: true,
        toggle_owner_earnings_p_check: true,
        toggle_owner_earnings_g_check: true,
        toggle_annual_sales_g_check: true,
        toggle_return_on_assets_check: true,
        toggle_days_receivables_check: true,
        toggle_efficiency_index_check: true,
        toggle_modified_z_check: true,
        toggle_interest_coverage_check: true,
        toggle_total_liabilities_nw_check: true,
        toggle_market_opp_index_check: true,
        toggle_ind_market_growth_check: true,
        check_technology_level: "on",
        check_customer_concentration: "on",
        check_customer_base: "on",
        check_key_employees: "on",
      };
      let i = 0;

      this.years.forEach((year) => {
        let parsedYear = i;
        if (year.year != null) {
          data["year_" + parsedYear] = year.year;
          data["year_" + parsedYear + "_check"] = true;
          data["revenue" + parsedYear] = year.businessRevenue;
          data["gross_margin" + parsedYear] = year.grossMargin;
          data["officers_compensation" + parsedYear] = year.officersComp;
          data["pre_tax_net_profit" + parsedYear] = year.preTaxNetProfit;
          data["income_expense_addbacks" + parsedYear] =
            year.incomeExpenseAddbacks;
          data["depreciation" + parsedYear] = year.depreciation;
          data["owner_replacement_compensation" + parsedYear] =
            year.ownerReplacementCompensation;
          data["operating_expenses" + parsedYear] = year.operatingExpenses;
          data["interest_expense" + parsedYear] = year.interestExpense;
          data["accounts_receivable" + parsedYear] = year.accountsReceivable;
          data["current_assets" + parsedYear] = year.currentAssets;
          data["total_assets" + parsedYear] = year.totalAssets;
          data["accounts_payable" + parsedYear] = year.accountsPayable;
          data["current_liabilties" + parsedYear] =
            year.otherCurrentLiabilities;
          data["long_term_liabilities" + parsedYear] =
            year.totalLongTermLiabilities;
          data["ft_emps" + parsedYear] = year.employment;
          data["avg_annual_wage" + parsedYear] = year.averageAnnualWage;
          i = i + 1;
        }
      });
      data.type = "valuation_main";
      data.action = "save";
      data.session_id = currentSession;
      data.report_id = profileId;
      data.profile_id = profileId;
      data.delayedSave = true;
      await this.$store.dispatch("user/saveReport", data).then((res) => {
        this.$store.dispatch("alerts/success", "Inputs applied.");

        let params = {
          product_id: profileId,
        };

        this.$store.dispatch("cart/accessProduct", params).then((res) => {
          if (res.cart) {
            this.$router.push({
              name: "Cart",
              params: { id: profileId },
            });
          }

          if (
            res.access ||
            (res.error && res.errorCode === "product_already_accessed")
          ) {
            this.$router.push({
              name: "VRAbouttheData",
              params: { id: profileId },
            });
          }
        });
      });
    },
    clearAll: async function () {
      this.$store.commit("V_SET_PROFILE_ID", null);
      this.$store.commit("V_SET_PROFILE_ID", null);
      this.$store.commit("V_SET_INDUSTRY", null);
      this.$store.commit("V_SET_MARKET_AREA", null);
      this.$store.commit("V_SET_SALES_CLASS", null);
    },
    checkAvailability: async function () {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (
        this.industry != null &&
        this.marketArea != null &&
        this.salesClass != null
      ) {
        this.operations = "";
        this.isDisabled = true;
        this.loading = true;

        let resZips = "0";
        let resArea = 0;
        let resMap_center = "0";
        let resMap_center_zip = "0";
        let resRadius = "0";

        await axios
          .get(process.env.VUE_APP_API_BASE_URL + "/info/IF_available", {
            params: {
              industry: this.getData(this.industry),
              area: this.getData(this.marketArea),
              sales_class: this.getData(this.salesClass),
              zips: this.marketArea.includes("zips")
                ? this.marketArea.split("[")[0]
                : null,
              map_center: resMap_center,
              map_center_zip: resMap_center_zip,
              radius: resRadius,
            },
          })
          .then((res) => {
            if (res.hasOwnProperty("data") && res.data.error) {
              this.$store.commit("SET_ERROR_BIT", true);
              this.$store.commit(
                "SET_ERROR_INFO",
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IF_available" <br>`
              );
              throw new Error(
                "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
              );
            }
            const { data } = res.data;
            if (data) {
              this.operations = data.firms;
              this.checkAccess();
            } else {
              this.operations = "";
              this.isDisabled = true;
              this.loading = false;
            }
            if (this.operations) this.notAvailable = false;
            else this.notAvailable = true;
          });
      } else {
        this.isDisabled = true;
        this.operations = "";
      }
    },
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
      subscriptions: (state) => state.user.user_subscriptions ?? null,
    }),
    industry() {
      return this.$store.getters.vIndustry;
    },
    marketArea() {
      return this.$store.getters.vMarketArea;
    },
    salesClass() {
      return this.$store.getters.vSalesClass;
    },
    profileId() {
      return this.$store.getters.vProfileId;
    },
  },
  watch: {
    industry(newValue, oldValue) {
      this.notAvailable = false;
      this.checkAvailability();
    },
    marketArea(newValue, oldValue) {
      this.notAvailable = false;
      this.checkAvailability();
    },
    salesClass(newValue, oldValue) {
      this.notAvailable = false;
      this.checkAvailability();
    },
    subscriptions() {
      if (this.subscriptions && this.subscriptions.length > 0)
        this.checkAccessByType();
    },
  },
  mounted() {
    trackSelectorViewed("valuation_report", "classic");
  },
  async created() {
    await this.clearAll();
  },
};
</script>
<style lang="scss">
.new-profile {
  margin-top: 20px;
  padding-top: 30px;
}

.profile-left-sec {
  padding: 10px;
  padding-left: 30px !important;
}

@media only screen and (max-width: 600px) {
  .fin-pro-card {
    margin-bottom: 10px;
  }

  .profile-left-sec {
    margin-bottom: 10px;
  }

  .fin-tab-list {
    margin-top: 350px;
  }

  #finantialProfileTabs .md-tabs-navigation {
    padding-left: 15px;
  }
}

@media screen and (max-width: 1280px) and (min-width: 600px) {
  .fin-tab-list {
    margin-top: 150px;
  }
}
</style>
